import { toWesternDigits } from './text';

/**
 * The association's settings (arqam `Setting`) as a form edits them, and
 * back to the row: used by the desk (doc 39).
 */

export type SettingsValues = {
  associationName: string;
  address: string;
  contactPhone: string;
  dueDays: number;
  firstReminderAfterDays: number;
  reminderEveryDays: number;
  publicArrearsAfterDays: number;
  publicArrearsRedAfterDays: number;
  publicArrearsMinAmount: number;
  /** "YYYY-MM" (month input), stored as the month's first day */
  publicArrearsSince: string;
  /** arqam doc 47: a photo of the meter with every reading. */
  readingPhotoAlways: boolean;
  /** arqam doc 46: expenses from this amount need a receipt photo. */
  receiptPhotoMinAmount: number;
};

/** Form values → the settings row: empty optional text → null. */
export function toSettingsFields(v: SettingsValues) {
  return {
    associationName: v.associationName.trim(),
    address: v.address?.trim() || null,
    // Printed as typed on documents ("for questions, call …").
    contactPhone: toWesternDigits(v.contactPhone ?? '').trim() || null,
    dueDays: v.dueDays,
    firstReminderAfterDays: v.firstReminderAfterDays,
    reminderEveryDays: v.reminderEveryDays,
    publicArrearsAfterDays: v.publicArrearsAfterDays,
    publicArrearsRedAfterDays: v.publicArrearsRedAfterDays,
    publicArrearsMinAmount: (v.publicArrearsMinAmount ?? 0).toFixed(2),
    publicArrearsSince: v.publicArrearsSince
      ? `${v.publicArrearsSince}-01`
      : null,
    readingPhotoAlways: Boolean(v.readingPhotoAlways),
    receiptPhotoMinAmount: (v.receiptPhotoMinAmount ?? 0).toFixed(2),
  };
}
